<script lang="ts">
  import { defineComponent } from 'vue';
  import { SurveyNotificationType } from '@/helpers/types';
  import { openSurvey } from '@/helpers/surveyHelpers';

  export default defineComponent({
    props: {
      data: {
        type: Object as () => SurveyNotificationType,
        required: true,
      },
    },
    emits: {
      close: () => true,
    },
    methods: {
      onNotificationClicked(): void {
        this.$emit('close');
        openSurvey();
      },
    },
  });
</script>

<template>
  <div @click="onNotificationClicked">
    <p>{{ data.body }}</p>
    <a href="#">{{ data.url }}</a>
  </div>
</template>
